import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Modal,
  Typography,
} from '@material-ui/core';
import React from 'react';

const UOAMobileFilters = ({
  styles,
  state,
  setFilters,
  handleCloseModal,
  getFilters,
}) => {
  return (
    <Modal
      style={styles.filtermodal}
      open={state.showModal}
      onClose={handleCloseModal}
    >
      <div style={styles.filterdivmodal}>
        Click on any button to filter the results.
        <Grid container spacing={2} style={{ marginTop: '10px' }}>
          <Grid item xs={12}>
            <Card style={styles.topCard}>
              <CardContent>
                <Typography
                  style={{
                    textAlign: 'center',
                    backgroundColor: '#404040',
                    color: 'white',
                    fontSize: '0.875rem',
                    fontWeight: 'bold',
                  }}
                >
                  Market Cap
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  style={
                    getFilters('all2')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('all2')}
                  size="small"
                >
                  All
                </Button>
                <Button
                  style={
                    getFilters('Small')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('Small')}
                  size="small"
                >
                  Small
                </Button>
                <Button
                  style={
                    getFilters('Mid')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('Mid')}
                  size="small"
                >
                  Mid
                </Button>
                <Button
                  style={
                    getFilters('Large')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('Large')}
                  size="small"
                >
                  Large
                </Button>
              </CardActions>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card style={styles.topCard}>
              <CardContent>
                <Typography
                  style={{
                    textAlign: 'center',
                    backgroundColor: '#404040',
                    color: 'white',
                    fontSize: '0.875rem',
                    fontWeight: 'bold',
                  }}
                >
                  Implied Volatility
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  style={
                    getFilters('all3')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('all3')}
                  size="small"
                >
                  All
                </Button>
                <Button
                  style={
                    getFilters('IVUP')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('IVUP')}
                  size="small"
                >
                  IV Up
                </Button>
                <Button
                  style={
                    getFilters('IVDOWN')
                      ? styles.activeButton
                      : styles.inactiveButton
                  }
                  onClick={() => setFilters('IVDOWN')}
                  size="small"
                >
                  IV Down
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};
export default UOAMobileFilters;



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/UOAMobileFilters.jsx